import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { VButtonDropdownComponent } from "@app/directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { DateService, DateUnit } from "@app/services/date.service";
import { CalendarDirection } from "@app/enum/CalendarDirection.enum";
import { CalendarService } from "@app/services/calendar.service";
import './v-date-picker.component.scss';

@Component({
    selector: 'v-date-picker',
    template: require('./v-date-picker.component.html')
})
export class VDatePickerComponent implements OnInit, OnChanges {

    @Input() @HostBinding("class.disabled") disabled: boolean;
    @Input() date: Date;
    @Input() minDate: Date;
    @Input() direction: CalendarDirection;
    @Input() showArrows: boolean = false;

    @Output() dateChanged = new EventEmitter<Date>();

    @ViewChild(VButtonDropdownComponent) buttonDropdown: VButtonDropdownComponent;

    // --

    label = "";

    get isPreviousDayDisabled(): boolean {
        let previousDay = this.dateService.addOrSubtractTime(this.date, -1, DateUnit.Day); 
        return !this.calendarService.isDayEnabled(previousDay, this.direction, [], null);
    }

    get isNextDayDisabled(): boolean {
        let nextDay = this.dateService.addOrSubtractTime(this.date, 1, DateUnit.Day); 
        return !this.calendarService.isDayEnabled(nextDay, this.direction, [], null);
    }

    constructor(
        private readonly dateService: DateService,
        private readonly calendarService: CalendarService) { }

    ngOnInit(): void {
        this.setLabel(this.date);
    }

    ngOnChanges(): void {
        if (this.date) {
            this.setLabel(this.date);
        }
    }

    onDateChanged($event: Date): void {
        this.date = $event;
        this.setLabel($event);
        this.buttonDropdown.closeDropdown();

        this.dateChanged.emit(this.date);
    }

    goToPreviousDay(): void {
        if (!this.isPreviousDayDisabled) {
            this.date = this.dateService.addOrSubtractTime(this.date, -1, DateUnit.Day); 
            this.setLabel(this.date);
            this.dateChanged.emit(this.date);
        }
    }

    goToNextDay(): void {
        if (!this.isNextDayDisabled) {
            this.date = this.dateService.addOrSubtractTime(this.date, 1, DateUnit.Day); 
            this.setLabel(this.date);
            this.dateChanged.emit(this.date);
        }
    }

    // --

    private setLabel(date: Date): void {
        this.label = this.dateService.formatDate(date);
    }

}
